import { Activity } from './activity';
export class Subactivity {
  constructor(
    public hash?: string,
    public name?: string,
    public activity?: Activity,
    public manual?: boolean,
    public time?: number
  ) { }

  clone() {
    return new Subactivity(
      this.hash,
      this.name,
      this.activity,
      this.manual,
      this.time
    );
  }

  get activityName() {
    return this.activity ? this.activity.name : '';
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/subactivity.ts